module.exports = __webpack_public_path__ + "static/media/baby-branco.fd5e611c.jpg";